import MuiRating, { type RatingProps } from "@mui/material/Rating";

export type { RatingProps };

export function Rating(props: RatingProps) {
  return <MuiRating {...props} />;
}
